import { FETCH_RESPONDENTS, SET_RESPONDENT_DATES } from "./respondant-store-constants";

// home-reducer.js
const initialState = {
  // ...existing state
  respondents: [],
  respondentDates: {
    startDate: new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0], // Default: 7 days ago
    endDate: new Date().toISOString().split('T')[0] // Today
  }
};

export const RespondantListReducer = (state = initialState, action) => {
  switch (action.type) {
    // ...existing cases
    case FETCH_RESPONDENTS:
      return {
        ...state,
        respondents: action.payload.respondents
      };
    case SET_RESPONDENT_DATES:
      return {
        ...state,
        respondentDates: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate
        }
      };
    default:
      return state;
  }
};
